import { render, staticRenderFns } from "./PatientImagesModal.vue?vue&type=template&id=2f45f81d&"
import script from "./PatientImagesModal.vue?vue&type=script&lang=js&"
export * from "./PatientImagesModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports